import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import './work.css'

const Work = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(10);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsCollection = collection(db, 'team-members');
        const snapshot = await getDocs(projectsCollection);
        const fetchedProjects = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          description: doc.data().description || 'No description available',
          isVisible: doc.data().isVisible !== undefined ? doc.data().isVisible : true,
        }));
  
        fetchedProjects.sort((a, b) => {
          const dateA = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : 0;
          const dateB = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : 0;
          return dateB - dateA;
        });
  
        setProjects(fetchedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setError("Failed to load projects. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);
  

  const ImageWithFallback = ({ src, alt }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const handleError = () => {
      setError(true);
      setImgSrc('/fallback-image.jpg');
    };

    return (
      <div className="image-container">
        {isLoading && !error && (
          <div className="loading-placeholder">
            <div className="loading-shimmer"></div>
          </div>
        )}
        <img
          src={imgSrc}
          alt={alt}
          onLoad={() => setIsLoading(false)}
          onError={handleError}
          className={`project-image ${isLoading ? 'hidden' : 'visible'}`}
        />
      </div>
    );
  };

  const loadMore = () => {
    setVisibleCount(prevCount => prevCount + 10);
  };

//   if (loading)
//   return (
//     <div className="loading-container">
//       <div className="spinner"></div>
//       <p>Loading issues...</p>
//     </div>
//   );
// if (error)
//   return (
//     <div className="error-container">
//       <div className="error-icon">⚠️</div>
//       <p>Error: {error}</p>
//     </div>
//   );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Stories...</p>
      </div>
    );
  }

  const visibleProjects = projects.filter(project => project.isVisible);
  const featuredProject = visibleProjects[0];
  const remainingProjects = visibleProjects.slice(1);

  const getProjectLink = (project) => {
    return project.slug ? `/stories/${project.slug}` : `/stories/${project.id}`;
  };

  const getFirstTextSection = (article) => {
    if (!article?.sections) return article?.content || '';
    const firstTextSection = article.sections.find(section => section.type === 'text');
    return firstTextSection?.content || article?.content || '';
  };
  

  return (
    <div className="works-containerr">
      {featuredProject && (
        <Link to={getProjectLink(featuredProject)} className="work-card featured-project">
          <div className="featured-image">
            <ImageWithFallback
              src={featuredProject.coverImage}
              alt={featuredProject.title}
            />
            <div
              className="overlayp"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", 
                paddingLeft: "2rem", 
                
              }}
            >
              <p style={{ fontFamily: "Poppins-SemiBold", fontSize: "1.1rem", color: "rgba(255, 255, 255, 0.8)", margin: 0, paddingBottom: "2rem"}}>
                {featuredProject.subtitle || "No description"}
              </p>
              <h2 style={{ fontSize: "2rem", color: "#fff", margin: "0.5rem 0" }}>
                {featuredProject.title}
              </h2>
            </div>
          </div>
        </Link>
      )}

      <div className="section__paddingadd">
        <h1 style={{fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "clamp(28px, 4vw, 37px)", fontWeight: "600", paddingTop: "3rem", paddingBottom: '1rem' }}>
          Discover all Stories
        </h1>
      </div>


      {remainingProjects.length === 0 ? (
        <div className="section__paddingadd">
          <p className="no-projects">No projects found</p>
        </div>
        
      ) : (
        <div className="work-cards  section__padding-work">
          {remainingProjects.slice(0, visibleCount).map((project) => (
            <Link key={project.id} to={getProjectLink(project)} className="work-card">
              <div className="featured-image">
                <ImageWithFallback
                  src={project.coverImage}
                  alt={project.title}
                />
                <div className="overlayp">
                  <p style={{fontFamily: "Poppins-Regular", color: "#CD3333"}}>{project.category || 'Category not specified'}</p>
                  <h2 style={{fontFamily: "Poppins-SemiBold", fontSize: "", lineHeight: "1.2"}}>{project.title || 'Untitled Project'}</h2>
                  <p 
                    dangerouslySetInnerHTML={{ 
                      __html: (() => {
                        const content = getFirstTextSection(project);
                        if (!content) return 'No content available';
                        return content.length > 150 ? content.slice(0, 150) + '...' : content;
                      })()
                    }}
                    style={{
                      fontFamily: "Poppins-Light", 
                      lineHeight: "1.3", 
                      fontSize: '14px', 
                      paddingTop: '6px'
                    }}
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {visibleCount < remainingProjects.length && (
        <div className="load-more-container">
          <button onClick={loadMore} className="load-more-button">
            Load More Stories
          </button>
        </div>
      )}
    </div>
  );
};

export default Work;








// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../firebase';
// import './work.css';
// import LazyLoad from 'react-lazyload';
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import { Header, WhatGPT3 } from '../../containers'

// const Work = () => {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [visibleCount, setVisibleCount] = useState(10);

//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const projectsCollection = collection(db, 'projects');
//         const snapshot = await getDocs(projectsCollection);
//         const fetchedProjects = snapshot.docs.map(doc => {
//           const data = doc.data();
//           console.log(`Project ${doc.id} data:`, data);
//           console.log(`Project ${doc.id} cover image:`, data.coverImage);

//           if (!data.coverImage) {
//             console.warn(`Project ${doc.id} is missing a cover image.`);
//           }

//           if (!data.slug) {
//             console.warn(`Project ${doc.id} is missing a slug.`);
//           }

//           return { id: doc.id, ...data };
//         });

//         fetchedProjects.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));

//         console.log('Fetched projects:', fetchedProjects);
//         setProjects(fetchedProjects);
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//         setError("Failed to load projects. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProjects();
//   }, []);

//   const loadMore = () => {
//     setVisibleCount(prevCount => prevCount + 10); 
//   };

//   if (loading) {
//     return <div>Loading projects...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   const visibleProjects = projects.filter(project => project.isVisible);
//   const featuredProject = visibleProjects[0];
//   const remainingProjects = visibleProjects.slice(1);

//   const getProjectLink = (project) => {
//     return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
//   };

//   return (
//     <>
//     <div className="works-container section__padding">
//       {featuredProject && (
//         <Link to={getProjectLink(featuredProject)} className="work-card">
//           <div className="featured-image">
//             <BlurhashImg src={featuredProject.coverImage} placeholderColor="#888"/>
//             <div className="overlayp">
//               <h2>{featuredProject.title}</h2>
//               <p>{featuredProject.description}</p>
//               <p>{featuredProject.location}</p>
//             </div>
//           </div>
//         </Link>
//       )}

//       <h1 style={{ color: "#CD3333", fontSize: "40px", fontWeight: "600", paddingTop: "2rem" }}>
//         Discover all Stories
//       </h1>
//       {/* <div className="work-cards">
//         {remainingProjects.slice(1, visibleCount).map((project) => (
//           <Link key={project.id} to={getProjectLink(project)} className="work-card">
//             <div className="featured-image">
//               {project.coverImage ? (
//                 <BlurhashImg 
//                   src={project.coverImage} 
//                   placeholderColor="#888"
//                   onError={(e) => {
//                     console.error('Error loading image:', project.coverImage);
//                     e.target.src = '/fallback-image.jpg'; 
//                   }}
//                 />
//               ) : (
//                 <div className="no-image">No Image Available</div>
//               )}
//               <div className="overlayp">
//                 <h2>{project.title || 'Untitled Project'}</h2>
//                 <p>{project.description || 'not specified'}</p>
//                 <p>{project.location || 'Location not specified'}</p>
//               </div>
//             </div>
//           </Link>
//         ))}
//       </div> */}
//       <div className="work-cards">
//         {remainingProjects.slice(0, visibleCount).map((project) => (
//           <Link key={project.id} to={getProjectLink(project)} className="work-card">
//             <div className="featured-image">
//               {project.coverImage ? (
//                 <BlurhashImg 
//                   src={project.coverImage} 
//                   placeholderColor="#888"
//                   onError={(e) => {
//                     console.error('Error loading image:', project.coverImage);
//                     e.target.src = '/fallback-image.jpg'; 
//                   }}
//                 />
//               ) : (
//                 <div className="no-image">No Image Available</div>
//               )}
//               <div className="overlayp">
//                 <h2>{project.title || 'Untitled Project'}</h2>
//                 <p>{project.description || 'Description not specified'}</p>
//                 <p>{project.location || 'Location not specified'}</p>
//               </div>
//             </div>
//           </Link>
//         ))}
//       </div>

//       {visibleCount < remainingProjects.length && (
//         <div className="load-more-container" style={{ display: 'flex', justifyContent: 'center' }}>
//           <button 
//             onClick={loadMore} 
//             className="load-more-button" 
//             style={{ color: "#CD3333", fontWeight: "600", textAlign: "center", paddingTop: "4rem" }}
//           >
//             Load More Stories
//           </button>
//         </div>
      
//       )} 
//     </div>
//     <WhatGPT3 />
//     </>
//   );
// };

// export default Work;





// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../firebase';
// import LazyLoad from 'react-lazyload';
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import './work.css';

// const Work = () => {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const projectsCollection = collection(db, 'projects');
//         const snapshot = await getDocs(projectsCollection);
//         const fetchedProjects = snapshot.docs.map((doc) => {
//           const data = doc.data();
//           return { id: doc.id, ...data };
//         });

//         // Sort projects by creation date
//         fetchedProjects.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));
//         setProjects(fetchedProjects);
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//         setError("Failed to load projects. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjects();
//   }, []);

//   if (loading) return <div>Loading projects...</div>;
//   if (error) return <div>Error: {error}</div>;

//   const visibleProjects = projects.filter((project) => project.isVisible);
//   const featuredProject = visibleProjects[0];

//   const getProjectLink = (project) => {
//     return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
//   };

//   return (
//     <div className="mx-auto section__padding">
//       <div className="category-buttons">
//         <h1 style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "37px", fontWeight: "600", lineHeight: "1.1" }}>
//           Explore <br /> Our Projects
//         </h1>
//         <button className='btn2' style={{ marginLeft: 'auto', marginTop: 'auto' }}>
//           <Link to="/work" style={{ fontFamily: "Poppins-Light", color: '#000000' }}>
//             View all Projects
//           </Link>
//         </button>
//       </div>

//       <div className="work-container flex flex-col lg:flex-row gap-8 mt-6">
//         {/* Featured Project - Large Image */}
//         <div className="flex-1">
//           {featuredProject && (
//             <Link to={getProjectLink(featuredProject)} className="block">
//               <div className="featured-project overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
//                 <BlurhashImg
//                   src={featuredProject.coverImage}
//                   placeholderColor="#888"
//                   className="w-full h-[400px] object-cover rounded-lg"
//                 />
//                 <h2 className="text-black text-2xl mt-4" style={{ fontFamily: "Poppins-SemiBold" }}>
//                   {featuredProject.title}
//                 </h2>
//                 <p className="text-black text-base mt-1" style={{ fontFamily: "Poppins-Regular" }}>
//                   {featuredProject.description || 'No description available.'}
//                 </p>
//               </div>
//             </Link>
//           )}
//         </div>

//         {/* 2x2 Grid for Remaining Projects */}
//         <div className="flex-1 grid grid-cols-2 gap-4">
//           {visibleProjects.slice(1, 5).map((project) => (
//             <Link key={project.id} to={getProjectLink(project)} className="block">
//               <div className="project-card overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
//                 <BlurhashImg
//                   src={project.coverImage}
//                   placeholderColor="#888"
//                   className="w-full h-[180px] object-cover rounded-lg"
//                   onError={(e) => {
//                     console.error('Error loading image:', project.coverImage);
//                     e.target.src = '/fallback-image.jpg';
//                   }}
//                 />
//                 <h2 className="text-black text-lg mt-2" style={{ fontFamily: "Poppins-SemiBold" }}>
//                   {project.title || 'Untitled Project'}
//                 </h2>
//                 <p className="text-black text-sm mt-1" style={{ fontFamily: "Poppins-Regular" }}>
//                   {project.description || 'No description available.'}
//                 </p>
//               </div>
//             </Link>
//           ))}
//         </div>
        
//       </div>
//     </div>
//   );
// };

// export default Work;







